import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ReplyAllIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 8L7 5L0 12L7 19L7 16L3 12L7 8ZM13 9L13 5L6 12L13 19L13 14.9C18 14.9 21.5 16.5 24 20C23 15 20 10 13 9Z"
      fill="currentColor"
    />
  </svg>
);

ReplyAllIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ReplyAllIcon);
